<template>
  <svg class="svg-icon" width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.25 9H7M7 9L3.625 5.625M7 9L3.625 12.375" stroke-width="2.25" stroke-linejoin="round" />
    <path
      d="M2.5 1.125H9.625C11.2819 1.125 12.625 2.46815 12.625 4.125V13.875C12.625 15.5319 11.2819 16.875 9.625 16.875H2.5"
      stroke-width="2.25" />
  </svg>
</template>

<script>
export default {
  name: "LoginIcon",
}
</script>

<style lang="scss" scoped>
path {
  stroke: var(--font-color);
}
</style>